module.exports = __webpack_public_path__ + "img/circle-book-open.9de423bc.svg";